import { cn } from "@/lib/utils";

export function EmptyState({ title, description, action, className, testId }) {
    return (
        <div
            className={cn(
                "flex flex-col items-center justify-center rounded-2xl border border-dashed border-nm-line bg-nm-surface px-6 py-16 text-center",
                className
            )}
            data-testid={testId}
        >
            <div className="mb-5 grid h-14 w-14 place-items-center rounded-2xl bg-nm-accent-soft">
                <span className="h-6 w-6 rounded-md border-2 border-nm-accent" />
            </div>
            <h3 className="text-lg font-semibold text-nm-ink">{title}</h3>
            {description && (
                <p className="mt-2 max-w-sm text-sm leading-relaxed text-nm-muted">{description}</p>
            )}
            {action && <div className="mt-6">{action}</div>}
        </div>
    );
}
